type AdMarketTile = {
  id: number
  name: string
  image_url: string
  click_url: string
  impression_url: string
}

const API_URL =
  'https://olntptiles.tiles.ampfeed.com/tiles?partner=olntptiles&sub1=10173&sub2=newtab&result=10&v=1.3'

const TILES_MOCK: AdMarketTile[] = [
  {
    name: 'Amazon',
    click_url:
      'https://olntptiles.ampxdirect.com?partner=olntptiles&sub1=10173&sub2=newtab&ctaid=74301&match-methods=deterministic&v=1.3&source=als_tiles',
    image_url:
      'https://amp-asset.45tu1c0.com/assets/1011/2f7d3fcc1beb0a9451ada5025f6310a6fc70873d847a15e9e45709749c9454c7.png',
    id: 74301,
    impression_url:
      'https://imp.mt48.net/static?id=7RHzfOIXjFEYsBdvIpkX4Zbd4ClmfQqrfZbXfpbWfpbk7ReNxR3UIG8zJmXUj9ekiFXwxYIZjF8XgClWfCxZ7R4dHQ8zJnErj%3DcO7R4dHQfz4Z2ZfplnHG3Z5FwqgCfX1ClX4Q8%2B4BINI9HuiF2z4Z2ZfplnHmcux%3DcvImauiF2zfQlWfp2%2B7ncqIr7VjGbuiF2zfCfk4Qxr4Qfnj9wWIBdvIpkY7R4TJr2uJREuHnEYgClnHr7wHG3vjnDuiF2z4pHrfBIWJ%3DcQIFdwJR2uiF2zfClYf2yy',
  },
  {
    name: 'Turbotax',
    click_url:
      'https://olntptiles.ampxdirect.com?partner=olntptiles&sub1=10173&sub2=newtab&ctaid=73780&match-methods=deterministic&v=1.3&source=als_tiles',
    image_url:
      'https://amp-asset.45tu1c0.com/assets/1217/538d45c5425f0777d9339531b18b2e39bcfc5f3452ed828fdc00a09935bf7d69.png',
    id: 73780,
    impression_url:
      'https://imp.mt48.net/static?id=7RHzfOIXjFEYsBdvIpkX4Zbd4ClmfQqrfZbXfpbWfpbk7ReNxR3UIG8zJmXUj9ekiFXwxYIZjF8XgClWfCxZ7R4dHQ8zJnErj%3DcO7R4dHQfz4Zfr1pbnHG3Z5FwqgCfX1ClX4Q8%2B4BINI9HuiF2z4Zfr1pbnHmcux%3DcvImauiF2zfQ8W4pfX7ncqIr7VjGbuiF2zfCDmfpLa1Clnj9wWIBdvIpkY7R4TJr2uJREuHnEYgC8nHr7wHG3vjnDuiF2z4Zqd1BIWJ%3DcQIFdwJR2uiF2zfClYf2yy',
  },
  {
    name: 'Invisalign',
    click_url:
      'https://olntptiles.ampxdirect.com?partner=olntptiles&sub1=10173&sub2=newtab&ctaid=74877&match-methods=deterministic&v=1.3&source=als_tiles',
    image_url:
      'https://amp-asset.45tu1c0.com/assets/1055/1ac05bc071b825060f0be949c8e089a72da2e18ee5e678f0911f08717cdf8d7d.png',
    id: 74877,
    impression_url:
      'https://imp.mt48.net/static?id=7RHzfOIXjFEYsBdvIpkX4Zbd4ClmfQqrfZbXfpbWfpbk7ReNxR3UIG8zJmXUj9ekiFXwxYIZjF8XgClWfCxZ7R4dHQ8zJnErj%3DcO7R4dHQfz4Z2a4ZxnHG3Z5FwqgCfX1ClX4Q8%2B4BINI9HuiF2z4Z2a4ZxnHmcux%3DcvImauiF2zfQl%2B4Cqr7ncqIr7VjGbuiF2zfCDkfC8%2B1pfnj9wWIBdvIpkY7R4TJr2uJREuHnEYgCfnHr7wHG3vjnDuiF2z4pH%2BfYIWJ%3DcQIFdwJR2uiF2zfClYf2yy',
  },
  {
    name: 'Groupon',
    click_url:
      'https://olntptiles.ampxdirect.com?partner=olntptiles&sub1=10173&sub2=newtab&ctaid=74649&match-methods=deterministic&v=1.3&source=als_tiles',
    image_url:
      'https://amp-asset.45tu1c0.com/assets/1039/10791517ba96637506d7704969bfb8dd82f88c6b425c20d60538fa738fdd37be.png',
    id: 74649,
    impression_url:
      'https://imp.mt48.net/static?id=7RHzfOIXjFEYsBdvIpkX4Zbd4ClmfQqrfZbXfpbWfpbk7ReNxR3UIG8zJmXUj9ekiFXwxYIZjF8XgClWfCxZ7R4dHQ8zJnErj%3DcO7R4dHQfz4Z2m4pqnHG3Z5FwqgCfX1ClX4Q8%2B4BINI9HuiF2z4Z2m4pqnHmcux%3DcvImauiF2zfQlr4QDZ7ncqIr7VjGbuiF2zfC2%2B4CqY1Cfnj9wWIBdvIpkY7R4TJr2uJREuHnEYgC2nHr7wHG3vjnDuiF2z4ZLW4BIWJ%3DcQIFdwJR2uiF2zfClYf2yy',
  },
  {
    name: 'Quickbooks',
    click_url:
      'https://olntptiles.ampxdirect.com?partner=olntptiles&sub1=10173&sub2=newtab&ctaid=24038&match-methods=deterministic&v=1.3&source=als_tiles',
    image_url:
      'https://amp-asset.45tu1c0.com/assets/1077/33e1624e1793f2ea41958d7ca975f99b1a368b1d2822d63adb27496258d4d85e.png',
    id: 24038,
    impression_url:
      'https://imp.mt48.net/static?id=7RHzfOIXjFEYsBdvIpkX4Zbd4ClmfQqrfZbXfpbWfpbk7ReNxR3UIG8zJmXUj9ekiFXwxYIZjF8XgClWfCxZ7R4dHQ8zJnErj%3DcO7R4dHQfzfQ2WfZLnHG3Z5FwqgCfX1ClX4Q8%2B4BINI9HuiF2zfQ2WfZLnHmcux%3DcvImauiF2zfQlY4CDZ7ncqIr7VjGbuiF2zfCf%2B4Z2Y4Clnj9wWIBdvIpkY7R4TJr2uJREuHnEYgCDnHr7wHG3vjnDuiF2z4pxW4BIWJ%3DcQIFdwJR2uiF2zfClYf2yy',
  },
]

export const useAdMarketTile = (): Ref<AdMarketTile[]> => {
  if (process.env.NODE_ENV === 'development') {
    return ref(TILES_MOCK)
  }

  const tiles: Ref<AdMarketTile[]> = ref([])

  onMounted(async () => {
    try {
      const { data } = await useFetch<{ tiles: AdMarketTile[] }>(API_URL)
      if (data.value?.tiles) tiles.value = data.value.tiles.map((item) => item)
    } catch (error) {
      console.error(error)
    }
  })

  return tiles
}
